import { Formik, getIn } from 'formik'
import React, { useEffect, useState } from 'react'
import { TuoiDati, MarkupPrezzi, AnteprimaOfferta } from './Steps'
import StepItem from '../../molecules/StepItem/StepItem'
import useTrans from '../../../hooks/useTrans'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import { useRouter } from 'next/router'
import { api } from '../../../utils'
import { CARRELLO, PROFILOAZIENDA } from '../../../utils/endpoint'
import LoadingSvg from '../../atoms/Loading/Loading'
import * as yup from 'yup'
import useCreateOffertaUtils from '../../../hooks/useCreaOffertaUtils'
import { useDispatch } from 'react-redux'

const validationSchema = (t) =>
  yup.object().shape({
    tuoi_dati: yup.object().shape({
      nome: yup.string().required(t('Nome obbligatorio')).nullable(),
      indirizzo: yup.string().required(t('Indirizzo obbligatorio')).nullable(),
      email: yup
        .string()
        .email(t('Formato email non valido'))
        .required(t('Email obbligatoria'))
        .nullable(),
      telefono: yup.string().required(t('Telefono obbligatorio')).nullable(),
      riferimento: yup.string().required(t('Riferimento obbligatorio')).nullable(),
    }),
  })

const RenderSteps = ({ step, setStep, formik, carrello }) => {
  const t = useTrans()
  return (
    <div className="w-container" style={{ marginTop: 25 }}>
      <h1 style={{ fontSize: 36, marginBottom: 24 }}>{t('Crea offerta')}</h1>
      <StepItem
        Modificabile={step > 0}
        placeholder={t('I tuoi dati')}
        setStep={setStep}
        stepNumber={1}
        open={step === 0}
        recap={<p>{}</p>}
      >
        <TuoiDati formik={formik} setStep={setStep} />
      </StepItem>
      <StepItem
        Modificabile={step > 1}
        placeholder={t('Markup da applicare sui prezzi')}
        setStep={setStep}
        stepNumber={2}
        open={step === 1}
      >
        <MarkupPrezzi formik={formik} setStep={setStep} carrello={carrello} />
      </StepItem>
      <StepItem
        Modificabile={step > 2}
        placeholder={t('Anteprima offerta')}
        setStep={setStep}
        stepNumber={3}
        open={step === 2}
      >
        <AnteprimaOfferta formik={formik} setStep={setStep} carrello={carrello} />
      </StepItem>
    </div>
  )
}

const created = new Date()
const createdAt = created.toLocaleDateString('it-IT')

const FormCreaOfferta = () => {
  const [step, setStep] = useState(0)
  const [carrello, setCarrello] = useState()
  const { initializeArticoliFromCart } = useCreateOffertaUtils()
  const t = useTrans()
  const router = useRouter()
  const dispatch = useDispatch()
  const [fetching, setFetching] = useState(false)
  const [tuoiDati, setTuoiDati] = useState({})

  useEffect(() => {
    if (!router?.isReady) {
      return
    }

    let isMounted = true
    const carrelloOfferta = router?.query?.editing
    const cartId = router?.query?.cart

    dispatch({ type: 'RESET_STATE' })
    setStep(0)
    setCarrello(undefined)
    setTuoiDati({})
    setFetching(!carrelloOfferta)

    if (carrelloOfferta) {
      api
        .get('/offerte/' + carrelloOfferta + '/', { params: { lang: router?.locale } })
        .then((res) => {
          if (!isMounted) return
          setCarrello(res?.data)
          initializeArticoliFromCart?.(res?.data)
        })
        .catch((err) => console.log(err))
    } else if (cartId) {
      api
        .get(CARRELLO + cartId, { params: { lang: router?.locale } })
        .then((res) => {
          if (!isMounted) return
          setCarrello(res?.data)
        })
        .catch((err) => console.log(err))
    }

    if (!router?.query?.editing) {
      api
        .get(PROFILOAZIENDA)
        .then((res) => {
          if (!isMounted) return
          const { email, telefono, ragione_sociale, indirizzo } = res?.data?.indirizzo_sede

          setTuoiDati({
            nome: ragione_sociale,
            email: email,
            telefono: telefono,
            indirizzo: indirizzo,
          })

          setFetching(false)
        })
        .catch((err) => {
          if (!isMounted) return
          setFetching(false)
          console.log(err)
        })
    }

    return () => {
      isMounted = false
    }
  }, [dispatch, router?.isReady, router?.locale, router?.query?.cart, router?.query?.editing])

  return carrello && !fetching ? (
    <Formik
      enableReinitialize
      validationSchema={validationSchema(t) || undefined}
      isInitialValid={router?.query?.editing ? true : false}
      onSubmit={(values) => console.log(values)}
      initialValues={
        router?.query?.editing
          ? {
              tuoi_dati: {
                nome: carrello?.nome,
                indirizzo: carrello?.indirizzo,
                email: carrello?.email,
                telefono: carrello?.telefono,
                riferimento: carrello?.riferimento,
                created: carrello?.created,
              },
            }
          : {
              tuoi_dati: {
                nome: null,
                indirizzo: null,
                email: null,
                telefono: null,
                riferimento: null,
                created: createdAt,
                ...(tuoiDati && tuoiDati),
              },
            }
      }
    >
      {(props) => (
        <RenderSteps
          formik={props}
          step={step}
          setStep={setStep}
          carrello={
            router?.query?.editing
              ? { ...carrello, righe_carrello: carrello?.righe_offerta }
              : carrello
          }
        />
      )}
    </Formik>
  ) : (
    <LoadingSvg />
  )
}

export default FormCreaOfferta

export const Input = ({ fieldName, formik, label, initialValue, type }) => {
  return (
    <div style={{ width: '100%', marginRight: 24 }}>
      <FormField
        label={label}
        status={
          getIn(formik?.touched, fieldName) && getIn(formik?.errors, fieldName)
            ? 'error'
            : getIn(formik.touched, fieldName) && 'success'
        }
        errorMessage={getIn(formik.errors, fieldName)}
      >
        <FormInput
          type={type || 'text'}
          value={getIn(formik?.values, fieldName) || initialValue}
          onBlur={formik.handleBlur(fieldName)}
          onChange={formik.handleChange(fieldName)}
        ></FormInput>
      </FormField>
    </div>
  )
}
